import React from 'react';
import range from 'ramda/src/range';
import View from '@bubble-ui/primitive-view';
import Surface from '@bubble-ui/primitive-surface';
import Group from '@bubble-ui/primitive-group';
import * as Grid from '@bubble-ui/particle-grid';
import HorizontalLine from './HorizontalLine';
import VerticalLine from './VerticalLine';
var ceil = Math.ceil;

var Mesh = function Mesh(_ref) {
  var left = _ref.left,
      top = _ref.top,
      height = _ref.height,
      width = _ref.width,
      designVersion = _ref.designVersion,
      invertedColor = _ref.invertedColor,
      selectingTarget = _ref.selectingTarget,
      visible = _ref.visible;
  return visible ? /*#__PURE__*/React.createElement(View, {
    style: {
      position: 'absolute',
      backgroundColor: 'transparent',
      left: left - 5,
      top: top - 5,
      borderColor: invertedColor ? 'rgba(0, 255, 0, 1)' : 'rgba(255, 85, 0, 1)',
      borderWidth: 5,
      borderStyle: 'solid',
      height: height + 10,
      width: width + 10,
      pointerEvents: 'none',
      zIndex: selectingTarget ? -1000 : 12312312
    }
  }, selectingTarget || /*#__PURE__*/React.createElement(Surface, {
    height: height,
    width: width
  }, /*#__PURE__*/React.createElement(Group, {
    id: "horizontalGridLines"
  }, range(0, ceil(height / Grid.SIZE) + 1).map(function (position) {
    return /*#__PURE__*/React.createElement(HorizontalLine, {
      key: position,
      invertedColor: invertedColor,
      designVersion: designVersion,
      position: position,
      width: width
    });
  })), /*#__PURE__*/React.createElement(Group, {
    id: "verticalGridLines"
  }, range(0, ceil(width / Grid.SIZE) + 1).map(function (position) {
    return /*#__PURE__*/React.createElement(VerticalLine, {
      key: position,
      invertedColor: invertedColor,
      designVersion: designVersion,
      position: position,
      height: height
    });
  })))) : null;
};

export default Mesh;
//# sourceMappingURL=index.js.map